<div class="ref-count-cell">
  <ng-container *ngIf="items?.length > 0; else empty">
    <ng-container *ngIf="items.length < 10; else countOnly">
      <button type="button" class="count-badge" (click)="toggle($event)">
        {{ items.length }} {{ label }}{{ items.length !== 1 ? 's' : '' }}
        <i class="pi pi-chevron-down count-chevron"></i>
      </button>
      <p-overlayPanel #op appendTo="body" styleClass="ref-count-panel">
        <div class="ref-list">
          <span
            *ngFor="let item of items"
            class="ref-list-item">
            {{ item.name || item.identifier || item.title }}
          </span>
        </div>
      </p-overlayPanel>
    </ng-container>
    <ng-template #countOnly>
      <button type="button" class="count-badge count-badge--modal" (click)="openModal()">
        {{ items.length }} {{ label }}{{ items.length !== 1 ? 's' : '' }}
        <i class="pi pi-external-link count-chevron"></i>
      </button>
      <p-dialog
        [(visible)]="modalVisible"
        [header]="items.length + ' ' + label + 's'"
        [modal]="true"
        [draggable]="false"
        [resizable]="false"
        [style]="{ width: '480px' }"
        appendTo="body">
        <div class="modal-list">
          <span
            *ngFor="let item of items"
            class="modal-list-item">
            {{ item.name || item.identifier || item.title }}
          </span>
        </div>
      </p-dialog>
    </ng-template>
  </ng-container>
  <ng-template #empty>
    <span class="ref-count-empty">—</span>
  </ng-template>
</div>
